import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthPermissionService } from '../../application/services/auth-permission.service';
import { AppPermission } from '../../domain/enums/app-permission.enum';

const ORDERED_FALLBACK_ROUTES: { path: string; permission: string[] }[] = [
  { path: '/dashboard', permission: [AppPermission.UiDashboardComplete] },
  { path: '/orders', permission: [AppPermission.UiOrders] },
  { path: '/portfolios', permission: [AppPermission.UiPortfolios] },
  { path: '/quality-controls', permission: [AppPermission.UiQualityControl] },
  { path: '/users', permission: [AppPermission.UiUsers] },
  { path: '/clients', permission: [AppPermission.UiClients] },
  { path: '/connections', permission: [AppPermission.UiCommunications] },
];

export const permissionGuard: CanActivateFn = (route) => {
  const permission = route.data['permission'] as string[] | undefined;
  if (!permission?.length) return true;

  const permissionService = inject(AuthPermissionService);
  const router = inject(Router);

  if (permissionService.hasAnyPermission(permission)) return true;

  const fallback = ORDERED_FALLBACK_ROUTES.find((r) =>
    permissionService.hasAnyPermission(r.permission)
  );

  return router.createUrlTree([fallback?.path ?? '/login']);
};
